import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import Layout from '../components/Layout'
import globalStyles from '../styles/global.module.css'
import styles from './Admin.module.css'
import apiConfig from '../config/api'

const Admin = () => {
  const { user } = useAuth()
  const [settings, setSettings] = useState({
    placeholderMode: true,
    hikeStartDate: null
  })
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [message, setMessage] = useState('')

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch(`${apiConfig.baseUrl}/api/settings`)
        if (!response.ok) {
          throw new Error('Failed to fetch settings')
        }
        const data = await response.json()
        setSettings({
          placeholderMode: data.placeholderMode,
          hikeStartDate: data.hikeStartDate ? new Date(data.hikeStartDate) : null
        })
      } catch (error) {
        console.error('Error fetching settings:', error)
        setMessage('Error loading settings')
      } finally {
        setLoading(false)
      }
    }

    fetchSettings()
  }, [])

  const handleSaveSettings = async () => {
    try {
      setSaving(true)
      setMessage('')
      
      const response = await fetch(`${apiConfig.baseUrl}/api/settings`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(settings)
      })
      
      if (!response.ok) {
        throw new Error('Failed to save settings')
      }
      
      setMessage('Settings saved successfully')
    } catch (error) {
      console.error('Error saving settings:', error)
      setMessage('Error saving settings')
    } finally {
      setSaving(false)
    }
  }

  const handlePlaceholderModeChange = (e) => {
    setSettings({
      ...settings,
      placeholderMode: e.target.checked
    })
  }

  const handleStartDateChange = (e) => {
    const date = e.target.value ? new Date(e.target.value) : null
    setSettings({
      ...settings,
      hikeStartDate: date
    })
  }

  const formatDateForInput = (date) => {
    if (!date) return ''
    return new Date(date).toISOString().split('T')[0]
  }

  return (
    <Layout>
      <div className={globalStyles.card}>
        <h2 className={styles.adminTitle}>Admin Dashboard</h2>
        
        <div className={styles.adminSection}>
          <h3>Hike Settings</h3>
          
          {loading ? (
            <p>Loading settings...</p>
          ) : (
            <form className={styles.settingsForm}>
              <div className={styles.formGroup}>
                <label className={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    checked={settings.placeholderMode}
                    onChange={handlePlaceholderModeChange}
                  />
                  <span>Placeholder Mode (Before Hike Starts)</span>
                </label>
              </div>
              
              <div className={styles.formGroup}>
                <label>
                  Hike Start Date
                  <input
                    type="date"
                    value={formatDateForInput(settings.hikeStartDate)}
                    onChange={handleStartDateChange}
                    className={styles.dateInput}
                  />
                </label>
              </div>
              
              <button
                type="button"
                className={globalStyles.button}
                onClick={handleSaveSettings}
                disabled={saving}
              >
                {saving ? 'Saving...' : 'Save Settings'}
              </button>
              
              {message && (
                <p className={message.includes('Error') ? styles.errorMessage : styles.successMessage}>
                  {message}
                </p>
              )}
            </form>
          )}
        </div>
        
        <div className={styles.adminSection}>
          <h3>Updates</h3>
          <div className={styles.adminActions}>
            <Link to="/update-progress" className={`${globalStyles.button} ${styles.fullWidthButton}`}>
              Add New Hiking Progress Update
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Admin 